import { colors } from './tokens';

// Petite palette de fonds solides prédéfinis pour la bannière et l'avatar du profil.
// Couleurs de marque Horméia (bleu, vert, lime) + quelques neutres. Pas d'import galerie ici.
export interface ProfileBackground {
  key: string;
  label: string;
  color: string;
}

export const PROFILE_BACKGROUNDS: ProfileBackground[] = [
  { key: 'blue', label: 'Bleu', color: colors.bluePrimary },
  { key: 'green', label: 'Cyan', color: colors.green },
  { key: 'lime', label: 'Violet', color: colors.greenLime },
  { key: 'night', label: 'Nuit', color: colors.blueNight },
  { key: 'ink', label: 'Encre', color: colors.ink },
  { key: 'slate', label: 'Ardoise', color: colors.grey700 },
  { key: 'cloud', label: 'Gris', color: colors.grey400 },
];

export const DEFAULT_BACKGROUND_KEY = 'blue';

// Résout une clé en couleur, repli sur le fond par défaut si la clé est nulle/inconnue.
export function backgroundColor(key: string | null | undefined): string {
  const found = PROFILE_BACKGROUNDS.find((b) => b.key === key);
  if (found) return found.color;
  return PROFILE_BACKGROUNDS.find((b) => b.key === DEFAULT_BACKGROUND_KEY)!.color;
}
